module.exports = __webpack_public_path__ + "img/rotation_1.d50427e9.png";